import { render, staticRenderFns } from "./NumberChip.vue?vue&type=template&id=58eb188e&scoped=true"
import script from "./NumberChip.vue?vue&type=script&lang=js"
export * from "./NumberChip.vue?vue&type=script&lang=js"
import style0 from "./NumberChip.vue?vue&type=style&index=0&id=58eb188e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eb188e",
  null
  
)

export default component.exports